import { Injectable, signal, WritableSignal } from '@angular/core';

import { DictionaryType } from '~shared/core/types/dictionary.type';
import { OptionalType } from '~shared/core/types/optional.type';

@Injectable({
    providedIn: 'root'
})
export class SharedDataService {
    private data: DictionaryType<any> = {};

    reset(): void {
        for (const key of Object.keys(this.data)) {
            delete this.data[key];
        }
    }

    setOrUpdateSignal<T>(key: string, data: T): void {
        if (typeof this.data[key]?.set === 'function') {
            this.data[key].set(data);
        } else {
            this.data[key] = signal(data);
        }
    }

    getOrCreateSignal<T>(key: string): WritableSignal<OptionalType<T>> {
        if (!this.data[key]) {
            this.data[key] = signal(undefined);
        }
        return this.data[key];
    }
}
